// extracted by mini-css-extract-plugin
export default {"searchWrapper":"header-search-bar_searchWrapper__MvjOC","search":"header-search-bar_search__Er1gd"};